import React, { Component } from "react";
import PropTypes from "prop-types";

import * as actions from "../../../redux/modules/actions";

import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
} from "react-bootstrap";
import renderHTML from "react-render-html";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import { designCenterActions } from "../../../redux/actions/designCenterActions";
import {
  renderAlert,
  clearAlert,
  alertsActions
} from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class AssetsColorList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_ASSET_COLOR',
      assetsColorList: [],
      activePage: 1,
      totalRecords: 0,
      loading: true,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Assets Color List"],
      links:['home','assets/color/list'],
      show: false,
      reasonForExecution: "",
      offerReasonForExecutionError: "",
      alert: false,
      limit: 100,
      orderby: "",
      direction: ""
    };

    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentDidMount() {
    const {
      actions: { getAllAssetsColor }
    } = this.props;
    getAllAssetsColor({ page: this.state.activePage, limit: this.state.limit });
    if (this.props.error) {
      this.setState({ loading: false });
    }
  }

  hadnlePageChange(){
    const {
      actions: { getAllAssetsColor }
    } = this.props;
    getAllAssetsColor({ page: this.state.activePage, limit: this.state.limit });
    if (this.props.error) {
      this.setState({ loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (nextProps.assetsColorList.data) {
      let resData = nextProps.assetsColorList.data;
      let setPageCount = resData.total / resData.per_page;
      this.setState({
        assetsColorList: resData.data,
        currentPage: resData.current_page,
        from: resData.from,
        last_page: resData.last_page,
        perPage: resData.per_page,
        to: resData.to,
        totalRecords: resData.total,
        pageCount: setPageCount
      });
    }

    if(this.props.delete !== nextProps.delete){
      if(nextProps.delete){
        if (nextProps.delete.response == 'success') {
          this.hadnlePageChange();
        }
      }
    }

    if (nextProps.assetsColorList || nextProps.error) {
      this.setState({ loading: false });
    }
  }

  displaySource = dcData => {
    return (
      '<div style="width:100px; background:' +
      dcData.value +
      '; height:35px">' +
      dcData.value +
      "<div>"
    );
  };

  handleDelete = catID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(catID);
          this.handleShow();
        })
      ]
    });
  };

  handleShow() {
    this.setState({ show: true });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  confirmDelete = assetColorId => {
    const {
      actions: { deleteAsset }
    } = this.props;
    deleteAsset(assetColorId);
  };

  stringUCWord(str, sType) {
    if (str) {
      str = str.replace(/_/g, " ");
      let sText = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });
      return sType == "name" ? "(" + sText + ")" : sText;
    }
  }

  render() {
    const {
      currentPage,
      totalRecords,
      perPage,
      pageCount,
      assetsColorList
    } = this.state;
    let contentRow;
    if (!isEmpty(assetsColorList)) {
      contentRow = assetsColorList.map((dc, index) => (
        <tr key={dc.asset_id}>
          <td>
            {this.stringUCWord(dc.asset_type, "asset_type")}{" "}
            {this.stringUCWord(dc.name, "name")}
          </td>
          <td>{renderHTML(this.displaySource(dc))}</td>
          <td>{dc.started_at}</td>
          <td>{dc.ended_at}</td>
          <td>{dc.status == 1 ? "Active" : "Inactive"}</td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_ASSET_COLOR') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/asset/color/edit/${dc.asset_id}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_ASSET_COLOR') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, dc.asset_id)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        {this.state.loading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
              {/*<Button
                bsSize="xsmall"
                bsStyle="success"
                onClick={() => this.context.router.history.push("/assets/list")}
              >
                {" "}
                Assets Listing{" "}
              </Button>*/}
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Assets Color List</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              {aclUtil.checkACL('ADD_ASSET_COLOR') ? (
              <div className="row">
                <div className="col-lg-12 text-right">
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => this.context.router.history.push("/asset/color/add")}
                  >
                    + Add Asset Color
                  </Button>
                </div>
              </div>
              ):("")}
              <div className="clearfix" />

              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th> Type </th>
                        <th> Source</th>
                        <th> Started At </th>
                        <th> Ended At </th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{contentRow}</tbody>
                  </table>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.designCenterReducer.loading,
    assetsColorList: state.designCenterReducer.assetsColorList,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    delete: state.designCenterReducer.delete,
    error: state.designCenterReducer.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...designCenterActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetsColorList));



// WEBPACK FOOTER //
// ./src/app/views/admin/designCenter/AssetsColorList.js